/**
 * ⚠️⚠️ LA CARTERA NO SE HA LEÍDO ENTERA, AUNQUE LA IMPORTACIÓN TERMINASE BIEN.
 *
 * MEDIDO en e2e el 2026-09-27 (#2647, #264): la cartera Solana 99TSE… terminó
 * «✓ Importadas: 4» con una compra del 19/09 fuera del libro —ningún nodo sirvió
 * su contenido— y su venta del 27/09 dentro: un lote a coste cero en el informe.
 * Las cifras que lo delataban vivían sólo en la metadata del trabajo.
 *
 * Cada línea lleva su remedio, porque no es el mismo: lo que el presupuesto dejó
 * a medias lo continúa la próxima sincronización; un contenido que ningún nodo
 * sirvió sólo lo vuelve a pedir una reimportación completa.
 *
 * La copia vive en `common` (`importSources.chainHistoryIncomplete.*`): el
 * catálogo `imports.json` está en su techo de tamaño.
 */

import type { ChainHistoryIncomplete } from '@bat/shared/contracts/jobs/import-job.dto'
import { useTranslation } from 'react-i18next'

export interface ChainHistoryIncompleteNoticeProps {
  gaps: ChainHistoryIncomplete
  testId?: string
}

const LINES = [
  ['unreadableTransactionCount', 'unreadableTransactions'],
  ['unreadAddressCount', 'unreadAddresses'],
  ['unreadEpochCount', 'unreadEpochs'],
  ['undatedEpochCount', 'undatedEpochs'],
] as const

/** True when at least one figure says part of the wallet was not read. */
export function hasChainHistoryGap(gaps: ChainHistoryIncomplete | undefined): boolean {
  return gaps !== undefined && LINES.some(([field]) => (gaps[field] ?? 0) > 0)
}

export const ChainHistoryIncompleteNotice = ({
  gaps,
  testId = 'chain-history-incomplete-notice',
}: ChainHistoryIncompleteNoticeProps) => {
  const { t } = useTranslation('common')
  if (!hasChainHistoryGap(gaps)) return null

  return (
    <div
      data-testid={testId}
      role="alert"
      className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-xs text-amber-200 [html[data-theme=light]_&]:text-amber-800 space-y-1.5"
    >
      <p className="font-semibold text-sm">⚠ {t('importSources.chainHistoryIncomplete.title')}</p>
      <ul className="space-y-0.5">
        {LINES.filter(([field]) => (gaps[field] ?? 0) > 0).map(([field, key]) => (
          <li key={field} data-testid={`${testId}-${key}`}>
            {t(`importSources.chainHistoryIncomplete.${key}`, { count: gaps[field] })}
          </li>
        ))}
      </ul>
      <p>{t('importSources.chainHistoryIncomplete.consequence')}</p>
    </div>
  )
}
